module.exports = __webpack_public_path__ + "static/media/logo.ef53d5aa.png";